import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./highlights_section.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";

export const IeltsPageHighlightsSection = () => {
  return (
    <section className={styles.section_onlinetest}>
      <div className="container">
        <h2 className={styles.title}>
          Program <span className={"color-orange"}>Highlights</span>
        </h2>
        <Grid container spacing={{ xs: 3, sm: 3, md: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_1}`}>
              <img
                className={styles.test_card_corner}
                src={getAssets("assets/images/elearning/lead/corner-green.png")}
                alt="ornament"
              />
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/power-button.svg")}
              />
              <h4 className={styles.test_title}>Start Now, Pay Later</h4>
              <div className={styles.test_desc}>
                To make your target IELTS scores more accessible than ever, we
                want to get you started right away. Sit for your first class
                before you pay your registration fee.
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_2}`}>
              <img
                className={styles.test_card_corner}
                src={getAssets(
                  "assets/images/elearning/lead/corner-violet.png"
                )}
                alt="ornament"
              />
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/training.svg")}
              />
              <h4 className={styles.test_title}>
                Certified IELTS Trainer with Proven Success Rate
              </h4>
              <div className={styles.test_desc}>
                Get the insider insight you need to score better in your IELTS,
                from trainers with years of experience coaching students to
                achieve their dream scores.
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_3}`}>
              <img
                className={styles.test_card_corner}
                src={getAssets(
                  "assets/images/elearning/lead/corner-orange.png"
                )}
                alt="ornament"
              />
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/desk-chair-orange.svg")}
              />
              <h4 className={styles.test_title}>Limited Seats</h4>
              <div className={styles.test_desc}>
                Giving each student the attention and support they need is
                UniSearch’s top priority - we stick to smaller batches to
                ensure every individual receives personalized guidance.
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className={`${styles.test_card} ${styles.test_card_4}`}>
              <img
                className={styles.test_card_corner}
                src={getAssets("assets/images/elearning/lead/corner-blue.png")}
                alt="ornament"
              />
              <ReactSVG
                className={styles.test_icon}
                src={getAssets("assets/images/elearning/diamond.svg")}
              />
              <h4 className={styles.test_title}>
                Exclusively Official Content
              </h4>
              <div className={styles.test_desc}>
                Our trainers exclusively use study materials designed by the
                official test administrators to give you real experience in how
                to ace the actual exam.
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default IeltsPageHighlightsSection;
